import Compressor from 'compressorjs';
import { COMPRESSION_RETRY_LIMIT, ERROR_NAME_COMPRESSION_FAILED, FIVE_MB, HALF_MB, ONE_MB, TEN_MB, } from './constants.js';
import { withRetry } from './utils.js';
export function compressImage(imageFile, options) {
    options?.hooks?.onBeforeCompression?.(imageFile);
    if (imageFile.size < HALF_MB)
        return Promise.resolve(imageFile);
    return withRetry(COMPRESSION_RETRY_LIMIT, remainingRetries => doCompressImage(imageFile, remainingRetries, options));
}
function doCompressImage(imageFile, remainingRetries, options) {
    return new Promise((resolve, reject) => {
        new Compressor(imageFile, {
            quality: getDesiredImageQuality(imageFile.size),
            checkOrientation: false,
            maxHeight: 2000,
            maxWidth: 2000,
            // Typed as `File` by compressorjs, but it may return the original input, which can be a Blob
            success(compressedFile) {
                options?.hooks?.onCompressionSucceeded?.(compressedFile, remainingRetries);
                if (compressedFile instanceof File) {
                    return resolve(compressedFile);
                }
                return resolve(new File([compressedFile], Date.now().toString(), { type: compressedFile.type }));
            },
            error(error) {
                error.name = ERROR_NAME_COMPRESSION_FAILED;
                options?.hooks?.onError?.(error, imageFile, remainingRetries);
                console.error(error);
                return reject(error);
            },
        });
    });
}
function getDesiredImageQuality(fileSize) {
    if (fileSize > TEN_MB) {
        return 0.2;
    }
    else if (fileSize > FIVE_MB) {
        return 0.3;
    }
    else if (fileSize > ONE_MB) {
        return 0.7;
    }
    else if (fileSize > HALF_MB) {
        return 0.7;
    }
    return 0.7;
}
